import { sectionFetch } from '@nx-paeonia/utils-http';
import { GlobalEvents } from '../../domain/global-events.enum.js';
import { getDefinitiveNode } from '../../helpers/safe-dom.helper.js';
import { map } from '@nx-paeonia/utils-result';
import { progressInstance } from '@nx-paeonia/utils-events';

export function refreshConfiguratorOnVariantChange() {
  document.body.addEventListener(GlobalEvents.ProductVariantChanged, async (event: any) => {
    progressInstance.start();

    const variantId = event.detail.variantId;
    if (!variantId) return;

    /**
     * The configurator cannot be open when the variant changes.
     * As the configurator does not support a variant input and is a full blocking
     * modal.
     *
     * This means we can safely fetch the full section, and get the updated product configurator
     * block HTML.
     *
     * The configurator should be added only once, as it has an ID we use.
     * The id is css-selector:`#simple-product-config`
     *
     * We can just replace the full dialog HTML but we receive the full product
     * section from the section API.
     *
     * ## URL
     * We can get the URL from the dialog data attribute `data-url`
     * This URL already contains the right parameters to get the section,
     * it just needs the variant parameter which we have data for in `variantId`
     */

    const dialog = getDefinitiveNode<HTMLDialogElement>('#simple-product-config');

    const url = new URL(window.location.href);
    if (dialog.dataset.section) url.searchParams.set('section_id', dialog.dataset.section);

    url.searchParams.set('variant', variantId);

    const result = await sectionFetch(url.toString());

    map(result, (section) => {
      const tempDiv = document.createElement('div');
      tempDiv.appendChild(section);

      const newDialog = tempDiv.querySelector<HTMLDialogElement>('#simple-product-config');
      if (!newDialog) throw new Error('No dialog found in fetched section HTML');

      dialog.replaceWith(newDialog);
      document.body.dispatchEvent(new CustomEvent(GlobalEvents.ProductConfiguratorReinitialized, { detail: { variantId } }));
      progressInstance.done();
    });
  });
}
